import angular from 'angular';
import myPaymentsList from './my-payments-list/my-payments-list';
import myPaymentsDetail from './my-payments-detail/my-payments-detail';

let myPaymentsModule = angular.module('app.payZone.myPayments', [
  myPaymentsList.name,
  myPaymentsDetail.name
]);

export default myPaymentsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/my-payments/my-payments.js
 **/